import React from "react"
import { graphql} from 'gatsby'
import Layout from "../../components/layout"
import { Container, Row, Col } from 'reactstrap'
import Breadcrumb  from "../../components/breadcrumb"
import styled from 'styled-components'
import Image from "gatsby-image"
import useSiteMetadata from '../../hooks/use-site-config'
import { Helmet } from "react-helmet"


export const query = graphql`
query {
  accesCamaraApp: file(relativePath: { eq: "assets/images/app/accesCamaraApp.PNG" }) {
    childImageSharp {
      fluid {
        ...GatsbyImageSharpFluid
      }
    }
  }
  cipeImag: file(relativePath: { eq: "assets/images/app/cipeImag.png" }) {
    childImageSharp {
      fluid {
        ...GatsbyImageSharpFluid
      }
    }
  }
  loginApp: file(relativePath: { eq: "assets/images/app/loginApp.PNG" }) {
    childImageSharp {
      fluid{
        ...GatsbyImageSharpFluid
      }
    }
  }
  registroApp: file(relativePath: { eq: "assets/images/app/registroApp.png" }) {
    childImageSharp {
      fluid{
        ...GatsbyImageSharpFluid
      }
    }
  }
  scanApp: file(relativePath: { eq: "assets/images/app/scanApp.PNG" }) {
    childImageSharp {
      fluid{
        ...GatsbyImageSharpFluid
      }
    }
  }

  dni: file(relativePath: { eq: "assets/images/app/dni.png" }) {
    childImageSharp {
      fluid {
        ...GatsbyImageSharpFluid
      }
    }
  }

  loginAppDni: file(relativePath: { eq: "assets/images/app/loginAppDni.png" }) {
    childImageSharp {
      fluid{
        ...GatsbyImageSharpFluid
      }
    }
  }
  registroAppDni: file(relativePath: { eq: "assets/images/app/registroAppDni.png" }) {
    childImageSharp {
      fluid{
        ...GatsbyImageSharpFluid
      }
    }
  }
  scanAppDni: file(relativePath: { eq: "assets/images/app/scanAppDni.png" }) {
    childImageSharp {
      fluid{
        ...GatsbyImageSharpFluid
      }
    }
  }


}
`


const CellImage = styled(Image)`
  margin-top:20px

  `
  var styleCol = {
    marginTop: '40px'
  };


export default function SmsApp(props) {
  
  const { siteTitle } = useSiteMetadata()

  const accesCamaraApp = props.data.accesCamaraApp.childImageSharp.fluid;
  const dni = props.data.dni.childImageSharp.fluid;

  
  const scanAppDni = props.data.scanAppDni.childImageSharp.fluid;
  const registroAppDni = props.data.registroAppDni.childImageSharp.fluid;
  const loginAppDni = props.data.loginAppDni.childImageSharp.fluid;

  return (
    <Layout >
      <Helmet>
          <meta charSet="utf-8" />
           <title>¿Cómo obtengo mi código con DNI? | {siteTitle}</title>
        </Helmet>
     
      <Container>
        <h1 className="text-center m-4">¿Cómo obtengo mi código con DNI?</h1>
        <Row className="justify-content-center">
       
        <Col xs="12" sm="6" md="3" >
        <p>1- Ingresar a la pantalla de la aplicación Portal Puntano desde su celular</p>
        <p>2- Seleccionar el botón "No tengo Contraseña"</p>
        <CellImage fluid={loginAppDni} style={styleCol}></CellImage>
        </Col>
        <Col xs="12" sm="6" md="3">
        <p>3-   Al seleccionar la opción “DNI” se visualizarán los siguientes campos bloqueados:</p>
            <ul>
            <li>DNI</li>
            <li>Número de Trámite del DNI</li>
            <li>Sexo</li>
            <li>Fecha de Nacimiento</li>
            </ul>
       <p><i>Estos datos se obtendrán al momento de realizar el escaneo del Código del DNI.</i></p>

        <CellImage fluid={registroAppDni}></CellImage>
        </Col>
        <Col xs="12" sm="6" md="3" >
        <p>4- Escanear el código QR de su DNI</p>
        <CellImage fluid={dni}></CellImage>
        <CellImage fluid={accesCamaraApp}></CellImage>
        </Col>
        
        <Col xs="12" sm="6" md="3">
        <p>5-Ingrese su número de teléfono</p>
        <p><i>Esto es importante ya que el Código llegará a este Teléfono registrado.</i></p>
        <p>6-Seleccionar el botón "Generar Código"</p>
        <p>Se visualizará un mensaje informando que se enviara el código a su celular por mensaje de texto</p>
        <CellImage fluid={scanAppDni}></CellImage>
        </Col>
        </Row>
      </Container>
     
      <Breadcrumb pageContext={props.pageContext} label="¿Cómo obtengo mi código con DNI?"/>

    </Layout>
  )
}
